import { render, staticRenderFns } from "./CarouselCourseCombo.vue?vue&type=template&id=36243e02"
import script from "./CarouselCourseCombo.vue?vue&type=script&lang=js"
export * from "./CarouselCourseCombo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports